"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-floriano-del-collio": {
    "dde9d356": [{
      "hkey": "0e86104b",
      "slug": "san-floriano-del-collio",
      "name": "San Floriano del Collio",
      "primary": true,
      "skipSearch": false
    }],
    "bukoje": [{
      "hkey": "0e86104b",
      "slug": "san-floriano-del-collio",
      "name": "San Floriano del Collio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;